import { useDispatch, useSelector } from "react-redux";
import { handleChangeDataBottomSheetEditPersonalInfo } from "../../../../../../redux/actions/pages/user/sheets/bottomSheetEditPersonalInfo";
import { Sheet } from 'react-modal-sheet';


const BottomSheetEditPersonalInfo = (props) => {

	const dispatch = useDispatch();
	
	const { isOpen } = useSelector(state => state.bottomSheetEditPersonalInfo);


    return (

		<Sheet isOpen={isOpen} onClose={() => dispatch(handleChangeDataBottomSheetEditPersonalInfo('isOpen', false))} detent="full-height">
	        <Sheet.Container>
	          	<Sheet.Header />
	          	<Sheet.Content>{/* Your sheet content goes here */}</Sheet.Content>
	        </Sheet.Container>
	        <Sheet.Backdrop />
      	</Sheet>



        
    );
}

export default BottomSheetEditPersonalInfo;
